import * as React from 'react'

import { Box, Button, type Colors } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'
import { translate } from 'modules/contracts/lib/translate'

interface Props {
  translations: { [key: string]: string }
  flow: ContractFlow
  form: Form
  isCurrentStepCompleted: boolean
  isSubmitting: boolean
  content: React.ReactNode
  background?: Colors
  onBackButtonClick: () => void
  onNextButtonClick: () => void
  onSubmit: () => void
}

const Footer = ({
  translations,
  flow,
  form,
  isCurrentStepCompleted,
  isSubmitting,
  content,
  background,
  onBackButtonClick,
  onNextButtonClick,
  onSubmit,
}: Props) => {
  const onSubmitConfirmed = () => {
    flow.trackSubmit(form)
    onSubmit()
  }

  const submitButtonCopy = translate(translations, 'submit')

  return (
    <Box
      width="full"
      height="s64"
      paddingX="s24"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      background={background || 'grey100'}
    >
      <Box flexDirection="row" gap="s4" alignItems="center">
        {content}
      </Box>
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Box
          width="s32"
          height="s32"
          justifyContent="center"
          alignItems="center"
          border={{
            all: {
              width: 's2',
              color: 'grey400',
              style: 'solid',
            },
          }}
          borderRadius={{
            all: 'abs100',
          }}
        >
          <Button
            type="secondary"
            disabled={!flow.hasPreviousStep()}
            onClick={() => onBackButtonClick()}
            iconName="arrow-left"
          />
        </Box>
        {flow.hasNextStep() && (
          <Button
            type="primary"
            onClick={() => onNextButtonClick()}
            disabled={!isCurrentStepCompleted}
          >
            {i18n.t('contract_versions.flows.footer.next')}
          </Button>
        )}
        {flow.isLastStep() && (
          <Button
            type="primary"
            onClick={() => onSubmitConfirmed()}
            disabled={!isCurrentStepCompleted || isSubmitting}
          >
            {submitButtonCopy}
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default observer(Footer)
